import type { PartnerDriverDetails, PartnerDriverSearchRow } from 'src/interfaces/partnerDriver'
import type { State } from '../reducers/types'

/**
 * Stored references only — never build a new array or object here, or every consuming
 * `useSelector` re-renders on each dispatch. Deduping and sorting steps happen in components
 * under `useMemo`.
 */
export const getPartnerDriverSearchResults = (state: State): PartnerDriverSearchRow[] => {
  return state.partnerDriver.searchResults
}

export const getPartnerDriverSearchLoading = (state: State): boolean => {
  return state.partnerDriver.searchLoading
}

export const getPartnerDriverSearchError = (state: State): string | null => {
  return state.partnerDriver.searchError
}

export const getPartnerDriver = (state: State): PartnerDriverDetails | null => {
  return state.partnerDriver.driver
}

export const getPartnerDriverLoading = (state: State): boolean => {
  return state.partnerDriver.driverLoading
}

export const getPartnerDriverError = (state: State): string | null => {
  return state.partnerDriver.driverError
}

export const getPartnerDriverNotFound = (state: State): boolean => {
  return state.partnerDriver.driverNotFound
}

export const getPartnerDriverSummary = (state: State): PartnerDriverSearchRow | null => {
  return state.partnerDriver.summary
}

export const getPartnerDriverSummaryLoading = (state: State): boolean => {
  return state.partnerDriver.summaryLoading
}

export const getPartnerDriverSummaryError = (state: State): string | null => {
  return state.partnerDriver.summaryError
}

export const getPartnerDriverSaving = (state: State): boolean => {
  return state.partnerDriver.saving
}
